<template>
  <div id="app">
    <el-container class="top container">
        <el-header>
          <el-row>
            <el-col :xs="24" :sm="24" :md="13" :lg="13" :xl="13">
              <div class="grid-content bg-purple logo"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="11" :lg="11" :xl="11" class="top_right hidden-sm-and-down">
              
            </el-col>
          </el-row>
        </el-header> 
        <!-- <div class="include hidden-md-and-down">
          <p>★  美国《工程索引（核心期刊）》（Ei Compendex）来源期刊</p>
          <p>★  荷兰《文摘与引文数据库》（Scopus）</p>
          <p>★  中国科技引文数据库（CSCD）来源期刊（核心库）</p>
          <p>★ 《中文核心期刊要目总览》收录期刊</p>
          <p>★  中国科技核心期刊</p>
        </div> -->
    </el-container>
    <div class="index-nav nav_menu container">
      <div class="index-nav-frame clearfix">
        <!-- logo -->
        <div
          class="nav-small"
          tabindex="-1"
        
          v-if="!isgzh"
        >
          <div
            class="nav-small-focus"
            tabindex="-1"
            v-if="isgzhl != 2"
          ></div>
          <img src="../assets/images/icon.png" id="topbtn"  v-if="isgzhl != 2" />
        </div>
        <!-- <div class="language hidden-sm-and-down leftfloat">
            {{ datetitme }}
        </div> -->
        <div class="leftfloat">
          <div
          v-for="(item, index) in NavList"
          :key="index"
          class="index-nav-frame-line pclist"
        >
          <span @click="$router.push(item.path)">{{
            item.name
          }}</span>
          <span v-if="item.children" class="rotator">
            <img src="../assets/images/down2.png" />
          </span>
          <div
            v-if="item.children"
            class="index-nav-frame-line-center"
            :class="'list' + index"
          >
            <div
              class="index-nav-frame-line-li"
              :class="'list' + index + '' + i"
              v-for="(val, i) in item.children"
              :key="i"
            >
              <span @click="$router.push(val.path)">{{
                val.name
              }}</span>
            </div>
          </div>
          <div class="index-nav-frame-line-focus"></div>
          </div>
        </div>
        <div class="leftfloat language hidden-sm-and-down">
          <a :href="Url + 'en'">English</a>
        </div>
        <div v-if="ismnav" ref="treeWrap">
          <div
            v-for="(items, indexs) in MNavList"
            :key="10 + indexs"
            class="index-nav-frame-line mobList index-nav-frame-linem"
            @click="topath(items.path)"
          >
            <span>{{ items.name }}</span>
          </div>
          <div class="leftfloat language hidden-sm-and-up">
            <a :href="Url + 'en'" style="color:#333;padding: 0 0px;">English</a>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import Search from "./Home/Search";
export default {
  name: "CommonHearde",
  components: {
    Search,
  },
  data() {
    return {
      isycb: false,
      ismnav: false,
      isgzhl: 0,
      islang: true,
      NavList: [
        { name: "首页", path: "/" },
        { name: "学报介绍", path: "/FixedBody?ItemId=10"},
        { name: "学术地位",
          children:[
            { name: "学报获奖", path: "/FixedBody?ItemId=60"},
            { name: "收录索引", path: "/FixedBody?ItemId=3500"},
          ]
        },
        { name: "编委简介",
          children:[
            { name: "现任编委", path: "/FixedBody?ItemId=1500"},
            { name: "历届编委", path: "/FixedBody?ItemId=20"},
          ]
        },
        { name: "文章检索", 
          path: "/AdvancedSearch",
          children: [
              { name: "过刊目录", path: "/dlistnum" },
              { name: "当期目录", path: "/OAList?IssueId=-1"},
              { name: "预出版", path: "/PreprintList" },
              {
                name: "下载排行",
                path: "/DownloadlistViewlist?Key=ReadRank",
              },
              {
                name: "浏览排行",
                path: "/DownloadlistViewlist?Key=ViewRank",
              },
            ]
        },
        { name: "投稿指南", path: "/NewsList?ColumnId=13"},
        { name: "下载专区", path: "/NewsList?ColumnId=19"}, 
        { name: "道德公约", path: "/FixedBody?ItemId=70"}, 
        { name: "订阅方式", path: "/FixedBody?ItemId=3600"},
        { name: "联系我们", path: "/FixedBody?ItemId=50" }
      ],
      MNavList: [
        { name: "首页", path: "/" },
        { name: "学报介绍", path: "/FixedBody?ItemId=10"},
        { name: "学报获奖", path: "/FixedBody?ItemId=60"},
        { name: "收录索引", path: "/FixedBody?ItemId=3500"},
        { name: "现任编委", path: "/FixedBody?ItemId=1500"},
        { name: "历届编委", path: "/FixedBody?ItemId=20"},
        { name: "预出版", path: "/PreprintList" },
        { name: "过刊目录", path: "/dlistnum" },
        { name: "当期目录", path: "/OAList?IssueId=-1"},
        { name: "下载排名", path: "/DownloadlistViewlist?Key=ReadRank"},
        { name: "浏览排名", path: "/DownloadlistViewlist?Key=ViewRank"},
        { name: "投稿指南", path: "/NewsList?ColumnId=13"},
        { name: "下载专区", path: "/NewsList?ColumnId=19"}, 
        { name: "道德公约", path: "/NewsList?ColumnId=70"}, 
        { name: "订阅方式", path: "/FixedBody?ItemId=3600"},
        { name: "联系我们", path: "/FixedBody?ItemId=50" }
      ],
      datetitme:''
    };
  },
  props: ["isgzh"],
  created() {
    if (sessionStorage.getItem("SetItem")) {
      let SetItem = JSON.parse(sessionStorage.getItem("SetItem"));
      SetItem.map((item) => {
        if (item.SetItemID == 4530) {
          item.Item_Value == "是" ? (this.isycb = true) : (this.isycb = false);
        }
        if (item.SetItemID == 2900) {
          item.Item_Value == "是"
            ? (this.islang = true)
            : (this.islang = false);
        }
      });
    };
    function getDateWeek(){
    var todayDate = new Date();
    var date = todayDate.getDate();
    var month= todayDate.getMonth() +1;
    var year= todayDate.getYear();
    var dateweek = "";
    if(navigator.appName == "Netscape")
    {
      dateweek = (1900+year) + "年" + month + "月" + date + "日 ";
    }
    if(navigator.appVersion.indexOf("MSIE") != -1)
    {
      dateweek = year + "年" + month + "月" + date + "日 ";
    }
    switch(todayDate.getDay())
    {
    case 0:dateweek += "星期日";break;
    case 1:dateweek += "星期一";break;
    case 2:dateweek += "星期二";break;
    case 3:dateweek += "星期三";break;
    case 4:dateweek += "星期四";break;
    case 5:dateweek += "星期五";break;
    case 6:dateweek += "星期六";break;
    }
    return dateweek;
    }
    this.datetitme = getDateWeek()
  },
  mounted() {
    let _this = this;
    if (this.$route.query) {
      this.isgzhl = this.$route.query.isgzh;
    }
    document.addEventListener("mouseup", (e) => {
      let tree = this.$refs.treeWrap;  
      if (e.target.id=='topbtn') {
          this.ismnav = !this.ismnav;
        } 
      if (tree) {
        if (!tree.contains(e.target)) {
          this.ismnav = false;
      }
      }
    }); 
  },
  methods: {
    topath(url) {
      this.$router.push(url);
      this.ismnav = false;
    },
  },
};
</script>
<style scoped>
.index-nav-frame-linem a {
  width: 100%;
  display: inline-block;
}
@media (max-width: 768px) {
  .language {
    background: #dedede;
    border-top: 1px solid #ccc;
    width: 100%;
    padding: 0 0 0 8px;
    
  }
  .quick {
    margin-top: -40px !important;
  }
}
.included{ height: 120px; overflow: hidden;}
.included li{ font-size:13px; color: #ab0000; line-height: 24px;text-shadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;font-weight: bold;}


#box{
    width: 100%;
    height: 120px;
    overflow: hidden;
    padding-left: 15%;
    margin-top: 8%;
}
.anim{
    transition: all 0.5s;
    margin-top: -30px;
}
#con1 li{
     font-size:14px; color: #ab0000; line-height: 24px;text-shadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;font-weight: bold;
}
.language,.language a{display: inline-block; color: #fff;font-size: 15px;padding: 0 10px;  font-weight: 600; height: 30px; line-height: 30px; position: relative; top:2px}
.language a:hover{color: #fff; background:#dd9d15; border-radius: 20px;}
.top_right{ text-align: right;}
.top{position: relative;}
.include{position: absolute; z-index: 999; bottom: -160%; left: 2%;}
.include p{ font-size: 15px; color: #ffcc00; line-height: 28px;}
</style>
